export interface ConfirmationDialogConfig {
  title: string;
  message: string;
  rejectBtnName: string;
  acceptBtnName: string;
  btnAlignment: string;
  hideRejectBtn?: boolean;
  showReason?: boolean;
  showPrice?: boolean;
  price?: number;
  showLastLessonDate?: boolean;
  lastLessonDate?: Date;
  maxDate?: Date;
}

export interface MatDialogRes {
  isConfirmed: boolean;
  reason?: string;
  price?: number;
  lastLessonDate?: Date;
}
